import { mapIds, mapObjectize } from 'cityads-v3/utils/apiUtils';
import { unique } from 'cityads-v3/utils/arrayUtils';
import {
  GET_NEWS_TYPES,
  GET_NEWS_TYPES_SUCCESS,
  GET_NEWS_TYPES_FAIL,
  GET_NEWS,
  GET_NEWS_SUCCESS,
  GET_NEWS_FAIL,
  GET_NEWS_BY_ID,
  GET_NEWS_BY_ID_SUCCESS,
  GET_NEWS_BY_ID_FAIL,
  GET_OFFER_NEWS,
  GET_OFFER_NEWS_SUCCESS,
  GET_OFFER_NEWS_FAIL,
} from '../actions/news';

const TYPE_COMPANY_NEWS = 22;
const TYPE_PROMO_EVENTS = 24;
const TYPE_CONTESTS = 26;
const TYPE_EVENTS = 28;

const initialState = {
  news: [],
  newsPage: 1,
  newsById: {},
  newsIdsByTypeId: {},
  newsIdsByTypeIdLoading: {},
  newsIdsByTypeIdLoaded: {},
  newsIdsByTypeIdErrored: {},
  isLoadingNews: false,
  isNewsLoaded: false,
  newsIdsByOfferId: {},
  newsIdsByOfferIdLoading: {},
  newsIdsByOfferIdLoaded: {},

  newsTypes: [],
  newsTypesById: {},
  newsTypeIdsByName: {},

  newsSections: [ 'all', 'promo', 'company_news', 'events' ],
  newsSectionsByName: {
    all: {
      name: 'all',
      types: [TYPE_COMPANY_NEWS, TYPE_PROMO_EVENTS, TYPE_CONTESTS, TYPE_EVENTS],
    },
    promo: {
      name: 'promo',
      types: [TYPE_PROMO_EVENTS, TYPE_CONTESTS],
    },
    company_news: {
      name: 'company_news',
      types: [TYPE_COMPANY_NEWS],
    },
    events: {
      name: 'events',
      types: [TYPE_EVENTS],
    },
  },

  isLoadingNewsTypes: false,
  isNewsTypesLoaded: false,
}

export default function news(state = initialState, action = {}) {
  switch (action.type) {
    case GET_NEWS_TYPES:
      return {
        ...state,
        isLoadingNewsTypes: true,
      };

    case GET_NEWS_TYPES_SUCCESS:
      return {
        ...state,
        newsTypes: mapIds(action.response.newsTypes),
        newsTypesById: {
          ...state.newsTypesById,
          ...mapObjectize(action.response.newsTypes),
        },
        newsTypeIdsByName: {
          ...state.newsTypeIdsByName,
          ...action.response.newsTypes.reduce((acc, type) => ({ ...acc, [type.name]: type.id }), {}),
        },
        isLoadingNewsTypes: false,
        isNewsTypesLoaded: true,
      };

    case GET_NEWS_TYPES_FAIL:
      return {
        ...state,
        isLoadingNewsTypes: false,
      };

    case GET_NEWS:
      return {
        ...state,
        isLoadingNews: true,
        newsIdsByTypeId: {
          ...action.additional.newsTypes.reduce((acc, typeId) => ({ ...acc, [typeId]: [] }), {}),
          ...state.newsIdsByTypeId,
        },
        newsIdsByTypeIdLoading: {
          ...state.newsIdsByTypeIdLoading,
          [action.additional.newsTypes.join(',')]: true,
        },
      };

    case GET_NEWS_SUCCESS:
      const news = action.additional.loadMore ?
        [ ...state.news, ...mapIds(action.response.news) ] :
        mapIds(action.response.news);

      return {
        ...state,
        news,
        newsPage: action.additional.page || 1,
        newsTotal: action.response.meta.total,
        newsById: {
          ...state.newsById,
          ...mapObjectize(action.response.news),
        },
        newsIdsByTypeId: action.response.news.reduce((acc, news) => {
          acc[news.type_id] = unique([ ...(acc[news.type_id] || []), news.id ]);
          return acc;
        }, state.newsIdsByTypeId),
        isLoadingNews: false,
        isNewsLoaded: true,
        newsIdsByTypeIdLoading: {
          ...state.newsIdsByTypeIdLoading,
          [action.additional.newsTypes.join(',')]: false,
        },
        newsIdsByTypeIdLoaded: {
          ...state.newsIdsByTypeIdLoaded,
          [action.additional.newsTypes.join(',')]: true,
        },
        newsIdsByTypeIdErrored: {
          ...state.newsIdsByTypeIdErrored,
          [action.additional.newsTypes.join(',')]: false,
        },
      };

    case GET_NEWS_FAIL:
      return {
        ...state,
        isLoadingNews: false,
        newsIdsByTypeIdLoading: {
          ...state.newsIdsByTypeIdLoading,
          [action.additional.newsTypes.join(',')]: false,
        },
        newsIdsByTypeIdErrored: {
          ...state.newsIdsByTypeIdErrored,
          [action.additional.newsTypes.join(',')]: true,
        },
      };

    case GET_NEWS_BY_ID:
      return {
        ...state,
        isLoadingNewsById: true,
        isNewsByIdFailed: false,
      };
    case GET_NEWS_BY_ID_SUCCESS:
      return {
        ...state,
        isLoadingNewsById: false,
        newsById: {
          ...state.newsById,
          [action.response.news.id]: action.response.news
        },
        isNewsByIdFailed: false,
      };
    case GET_NEWS_BY_ID_FAIL:
      return {
        ...state,
        isLoadingNewsById: false,
        isNewsByIdFailed: true,
      };

    case GET_OFFER_NEWS:
      return {
        ...state,
        newsIdsByOfferId: {
          [action.additional.offerId]: [],
          ...state.newsIdsByOfferId,
        },
        newsIdsByOfferIdLoading: {
          ...state.newsIdsByOfferIdLoading,
          [action.additional.offerId]: true,
        },
      };

    case GET_OFFER_NEWS_SUCCESS:
      return {
        ...state,
        newsById: {
          ...state.newsById,
          ...mapObjectize(action.response.news),
        },
        newsIdsByOfferId: {
          ...state.newsIdsByOfferId,
          [action.additional.offerId]: action.response.news.map(newsItem => newsItem.id),
        },
        newsIdsByOfferIdLoading: {
          ...state.newsIdsByOfferIdLoading,
          [action.additional.offerId]: false,
        },
        newsIdsByOfferIdLoaded: {
          ...state.newsIdsByOfferIdLoading,
          [action.additional.offerId]: true,
        },
      };

    case GET_OFFER_NEWS_FAIL:
      return {
        ...state,
        newsIdsByOfferIdLoading: {
          ...state.newsIdsByOfferIdLoading,
          [action.additional.offerId]: false,
        },
      };

    default:
      return state;
  }
}
